<template>
  <div >
    <div id="chart-container"></div>
    <div class="chart-tag">
      <div class="tag-item"
          v-for="c in healthCheckAlarmCategoryList"
          :key="c.id"
      > 
      <p :style="getLegendCss(c.id)"></p>
      <p> {{ c.name }} </p> 
      </div>
    </div>
    <div id="horizontalTimelineChartContainer" class="chartContainer">
      <div id="horizontalTimelineChart" class="chart" :style="{'height': '160px','border': '1px solid #ccc','width': horizontalTimelineChartWidth}"></div>
    </div>
  </div>

</template>

<script>
import { mixins } from '@/views/common/mixins'
import * as echarts from 'echarts';
import _ from 'lodash'

export default {
  name: 'HorizontalTimeline',
  mixins: [mixins],
  props: {
    alarmProfile: {
      require: true,
      default: undefined,
      type: Array
    },
    dateRange:{
      require: true,
      default: undefined,
      type: Array
    }
  },
  mounted() {    
  },
  data() {
    return {
      healthCheckAlarmCategoryList:[],
      noteList:[],
      horizontalTimelineChartWidth:'100%',
      number: 11,
      spanWidth: '80px',
      timelineWidth: '1100px', // 時間軸寬度，隨點數越多而增加，再透過scroll bar 去移動
      activeItem: undefined,
      // 水管家使用到的有r0301(category:3)
      // 水管家使用到的有r0403(category:4)
      // 水管家使用到的有r0405(category:4)
      // 水管家使用到的有r0406(category:4)
      // 水管家使用到的有r0412(category:4)
      // 水管家使用到的有r0501(category:5)
      // 水管家使用到的有r0701(category:7)
      // 水管家使用到的有r0801(category:8)
      // 水管家使用到的有r0802(category:8)
      colorMap: {
        1: '#b6a2de',
        2: '#5ab1ef',
        3: '#ffb980',
        4: '#d87a80',
        5: '#90aec7',
        6: '#e5cf0d',
        7: '#97b552',
        8: '#1088eb',
      }
    }
  },
  async created() {
    await this.$store.dispatch("getAlarmCategory")
    if (this.alarmProfile) {
      this.number = this.alarmProfile.length // 異常案件數量
      // 依數量 設定 時間軸 每點文字 寬度 及 時間軸寬度
      
      if (this.number >= 40) {
        let w = 1100/55
        // let w = 35
        this.spanWidth = w + 'px'
        this.timelineWidth = this.number * 60 + 'px'
      } else if (this.number > 16) {
        let w = 1100/30
        // let w = 35
        this.spanWidth = w + 'px'
        this.timelineWidth = this.number * 60 + 'px'
      } else {
        this.spanWidth = '80px'
        this.timelineWidth = '1100px'
      }
    }
  },
  computed:{
    cssVars() {
      return {
        "--spanWidth": this.spanWidth,
        "--number": this.number,
        "margin-top": '30px',
        "margin-bottom": '40px',
        "--timelineWidth": this.timelineWidth
      };
    },
    
  },
  watch: {
    alarmProfile(val) {
      const alarmProfileCategoryIdList = []
      _.forEach(val, v => {
        alarmProfileCategoryIdList.push(v.type.categoryId)
      })
      
      this.healthCheckAlarmCategoryList = this.$store.state.alarmCategoryList.filter(alarmCategory => alarmProfileCategoryIdList.includes(alarmCategory.id))
      // 體檢卡只有一種Category(連續用水),20230610
      // this.healthCheckAlarmCategoryList = this.$store.state.alarmCategoryList.filter(alarmCategory => alarmCategory.id == 5)

      this.setNoteList(val)
      this.renderChart(val);
      this.number = val.length
      
      // 依數量 設定 時間軸 每點文字 寬度 時間軸寬度
      if (this.number >= 40) {
        let w = 1100/55
        // let w = 35
        this.spanWidth = w + 'px'
        this.timelineWidth = this.number * 60 + 'px'
      } else if (this.number > 16) {
        let w = 1100/30
        // let w = 35
        this.spanWidth = w + 'px'
        this.timelineWidth = this.number * 60 + 'px'
      } else {
        this.spanWidth = '80px'
        this.timelineWidth = '1100px'
      }
    },
  },
  methods: {
    async renderChart(alarmProfile) {
      // 起始日期
      const startDate = this.$moment(this.dateRange[0])
      // 結束日期
      const endDate = this.$moment(this.dateRange[1])
      // 起始日期和結束日期間的月份數
      const diifMonths = this.$moment(this.dateRange[1]).diff(this.$moment(this.dateRange[0]), 'months')
      
      // 第一個X軸Label的位置
      let firstPointXAxis = null
      var chartDom = document.getElementById('horizontalTimelineChart');
      var myChart = echarts.init(chartDom);

      // 圖表資料
      const data = []
      if(_.isArray(alarmProfile))
      {
          const groupByDayList = []
          _.forEach( alarmProfile, v =>
          {
            const exist = groupByDayList.find(e => this.$moment(e['xAxisDate']).isSame(v.openedOn, 'day'))
            if(exist) {
              exist['name'].push(v.type.name)
            } else {
              let groupByDay = {
                xAxisDate: this.$moment(v.openedOn).format('YYYY-MM-DD'),
                yAxisValue: 0,
                categoryId: v.type.categoryId,
                name: [],
              }
              groupByDay['name'].push(v.type.name)
              groupByDayList.push(groupByDay)
            }

            

            // const xAxis_date = this.$moment(v.openedOn).format('YYYY-MM-DD HH:mm:ss')
            // const yAxis_value = 0
            // const categoryId = v.type.categoryId
            // const name = v.type.name
            // const d = [xAxis_date, yAxis_value, categoryId, name, this.colorMap]
            // data.push(d)
            // if(!firstPointXAxis) {
            //   firstPointXAxis = xAxis_date;
            // }
          })

          _.forEach( groupByDayList, v =>{
            if(!firstPointXAxis) {
              firstPointXAxis = v.xAxisDate;
            }
            
            data.push([v.xAxisDate, 0, v.categoryId, v.name, this.colorMap])
          })
      }

      // 體檢卡只有一種Category(連續用水),20230610
      // if(_.isArray(alarmProfile))
      // {
      //     _.forEach( alarmProfile, v =>
      //     {

      //       const category5 = this.$store.state.alarmCategoryList.find(alarmCategory => alarmCategory.id == 5)
      //       let category5Name = category5 ? category5.name : '連續用水'

      //       const xAxis_date = this.$moment(v.openedOn).format('YYYY-MM-DD')
      //       const yAxis_value = 0
      //       const categoryId = 5
      //       const name = category5Name
      //       const d = [xAxis_date, yAxis_value, categoryId, name, this.colorMap]
      //       data.push(d)
      //       if(!firstPointXAxis) {
      //         firstPointXAxis = xAxis_date;
      //       }
      //     })
      // }
        
      // 圖表設定
      const option = {
        grid: {
          top: 50, // 調整圖表的上邊距
          left: 60,  // 調整圖表的左邊距
          bottom: 10,  // 調整圖表的下邊距
          right: 60,  // 調整圖表的右邊距
          containLabel: true
        },
        tooltip: {
          formatter: function (params) {
            let name_html = ''
            _.forEach( params.value[3], v =>{
              if(name_html) {
                name_html += '/' + v
              } else {
                name_html = v
              }
            })

            // 體檢卡只有一種Category(連續用水),20230610
            // name_html = params.value[3]
            
            return (
              '<div class="customTooltip-container" style="">'+
              '<div class="customTooltip-element" style="font-size: 14px; border-bottom: solid; border-bottom-width: 1px">' + params.value[0] + '</div>' + 
              '<div class="customTooltip-element" style="font-size: 12px;">' + name_html + '</div>' +
              '</div>'
            );
          }
        },
        xAxis: {
          type: 'time',
          min: startDate.format('YYYY-MM-DD'),  // 起始時間
          max: endDate.format('YYYY-MM-DD'),  // 結束時間
          minInterval: 3600 * 1000 * 24 * 30, // 最小時間分隔
          maxInterval: 3600 * 1000 * 24 * 30, // 最大時間分隔
          boundaryGap: false,
          splitLine: {
            show: false //是否顯示x軸分隔線
          },
          axisLabel:{
            formatter: function (value) {
              return echarts.format.formatTime('yyyy/MM/dd', value);
            },
            margin:30  // 調整標籤與軸線之間的距離
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0],
          splitLine: {
            show: false //是否顯示y軸分隔線
          }
        },
        series: [
          {
            type: 'scatter',
            // symbolSize: function (val) {
            //   return val[2] * 2;
            // },
            symbolSize:20,
            data: data,
            animationDelay: function (idx) {
              return idx * 5;
            },
            itemStyle: {
              // 顏色對應
              color: function (params) {
                if(params && params.data) {
                  const categoryId = params.data[2] 
                  const _colorMap = params.data[4]
                  return _colorMap[categoryId]
                }
              }
            }
            
          }
        ]
      };

      option && myChart.setOption(option);
      
      // 設定圖表長度
      await this.setLength(diifMonths)
      // 重畫圖表
      myChart.resize();
      
      // 取得第一筆資料的橫軸位置並轉成Pixel
      var point = myChart.convertToPixel({seriesIndex:0}, [firstPointXAxis, 0]);
      
      var horizontalTimelineChartContainer = document.getElementById('horizontalTimelineChartContainer');

      // 設定Scrollbar橫向位置
      horizontalTimelineChartContainer.scrollLeft = point[0] * 0.95
    },
    setLength(diifMonths) {
      this.horizontalTimelineChartWidth = diifMonths && diifMonths > 6 ? (diifMonths * 150) + 'px' : '99%'
    },
    setNoteList(alarmProfile) {
      this.noteList = []
      
      if(_.isArray(alarmProfile))
      {
          _.forEach( alarmProfile, v =>
          {

            let obj = {
              date: this.$moment(v.openedOn).format('YYYY/MM/DD'),
              note: v.type.note
            }

            this.noteList.push(obj)

          })
      }
    },
    getLegendCss(categoryId) {
      return {
        "background-color": this.colorMap[categoryId],
        "border": '2px solid' + this.colorMap[categoryId],
        "border-radius": "50%",
        "width": "5px",
        "height": "5px",
      }
    }
  }
}
</script>

<style lang="scss"  scoped>
.scrollbar-flex-content {
  display: flex;
}
  $color-background: #FFFF;
  // $width: 1100px;
  $width: var(--timelineWidth);
  $number: var(--number);
  $spanWidth: var(--spanWidth);

  body {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: $color-background;
  }

  ol, .alarmItem {
    margin: 0;
    padding: 0;
    font-size: 6px;
  }

  ol {
    display: flex;
    width: $width;
    justify-content: space-around;
    position: relative;
    
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 3px;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0, -50%);
      z-index: -1;
    }
  }

  .alarmItem {
    list-style-type: none;
    position: relative;
    cursor: pointer;
    
    &:after {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      transition: background-color .2s ease;
    }

  }

  .alarmItem:hover:after {
    background-color: $color-background;
  }

  .alarmItem.active:after {
    background-color: $color-background;
  }

  .alarmItem span {
    position: absolute;
    top: calc(100% + 15px);
    bottom: calc(100% + 15px);
    left: 50%;
    transform: translate(-50%, 0);
    display: inline-block;
    text-align: center;
    width: $spanWidth
  }

  ::v-deep .el-scrollbar__wrap {
    width: 1300px;
    height: calc(100% + 17px); 
  }

  .chartContainer {
  width: 100%;
  overflow-x: auto;
}

.chart {
  width: max-content;
}

// .customTooltip-container {
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
// }

// .customTooltip-element {
//   margin-bottom: 10px; /* 設置元素之間的垂直間距 */
// }

// .customTooltip-separator {
//   width: 100%;
//   height: 1px;
//   background-color: #000; /* 設置分隔線的顏色 */
//   margin-bottom: 10px; /* 設置分隔線下方的間距 */
// }

.horizontalTimelineChart {
  height: "200px";
  border: "1px solid #ccc";
  width: 100%;
}
  
</style>